// Alto de la app con el teclado del celular abierto.
//
// Android (Chrome): el viewport meta pide `interactive-widget=resizes-content`,
// así el teclado achica la página y el layout (header, hilo, composer) entra
// entero sobre el teclado. iOS (Safari) ignora esa opción: el teclado sólo
// achica el visual viewport y Safari corre la página para mostrar el campo,
// dejando el composer tapado o el hilo cortado. Por eso la app toma el alto
// del visual viewport (variable --app-height, ver styles.css) y vuelve la
// página arriba de todo.

export function startKeyboardViewport(win = typeof window !== "undefined" ? window : null) {
  const vv = win?.visualViewport;
  if (!vv) return () => {};
  const root = win.document.documentElement;

  const apply = () => {
    // Con zoom de pellizco el visual viewport también se achica: no es el
    // teclado, la app no tiene que encogerse.
    if (vv.scale && vv.scale > 1.01) return;
    root.style.setProperty("--app-height", `${Math.round(vv.height)}px`);
    // Safari deja la página desplazada al abrir el teclado: el scroll vive en
    // el hilo, la página nunca tiene que moverse.
    if (win.scrollY !== 0) win.scrollTo(0, 0);
  };

  apply();
  vv.addEventListener("resize", apply);
  vv.addEventListener("scroll", apply);
  return () => {
    vv.removeEventListener("resize", apply);
    vv.removeEventListener("scroll", apply);
  };
}

/** ¿Teclado en pantalla? (pantalla táctil sin mouse: celular o tablet). */
export function hasOnScreenKeyboard(win = typeof window !== "undefined" ? window : null) {
  return Boolean(win?.matchMedia?.("(pointer: coarse)").matches);
}
